import React from "react";
import { SvgIcon } from "@mui/material";

export const FlueIcon = () => {
  return (
    <SvgIcon viewBox="0 0 24 24">
      {/* Hollow rectangle representing the flue passage */}
      <rect
        x="8"
        y="4"
        width="8"
        height="16"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SvgIcon>
  );
};
